module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-square-8ee98e84.svg";